const firebase = global.firebase;

export default firebase;
